import template from './invoice-ncf.html';
import controller from './invoice-ncf.controller';
import './invoice-ncf.scss';

let InvoiceNcfComponent = {
  bindings: {
    ncfObservable: '<'
  },
  template,
  controller
};

export default InvoiceNcfComponent;



// WEBPACK FOOTER //
// ./src/app/pages/invoice-ncf/invoice-ncf.component.js